////////LIBRARY/////////
import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import _, { map, find, includes, isEqual } from 'lodash'
import { useSelector, shallowEqual } from 'react-redux'
///////COMPONENTS///////
import Theme from '../../theme/theme'
/////////ASSETS/////////
import valitatedStep from '../../assets/icones/global/check.svg'

/////////STYLED/////////
const TabsNavigationsRaftersWrapper = styled.div`
	display: flex;
	padding-left: 10px;
	& > a:first-child {
		margin-left: 0px;
	}
`
// TABS NAV RAFTERS
const TabNavContent = styled(Link)`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	position: relative;
	margin-left: 5px;
	width: 203px;
	height: 34px;
	cursor: ${(props) => (props.isClickable ? 'pointer' : 'not-allowed')};
`
const FirstArrowBack = styled.div`
	width: 34px;
	height: 34px;
	background-color: ${(props) => props.rafterColor};
	position: absolute;
	top: 0px;
	right: 179px;
`
const TabNavArrowTop = styled.div`
	width: 100%;
	height: 50%;
	background: ${(props) => props.rafterColor};
	transform: skew(45deg, 0deg);
	border-left: 1px solid ${(props) => props.rafterColor};
	border-right: 1px solid ${(props) => props.rafterColor};
	border-top: 1px solid ${(props) => props.rafterColor};
	border-bottom: 1px solid ${(props) => props.rafterColor};
`
const TabNavArrowBottom = styled.div`
	width: 100%;
	height: 50%;
	background: ${(props) => props.rafterColor};
	transform: skew(-45deg, 0deg);
	border-left: 1px solid ${(props) => props.rafterColor};
	border-right: 1px solid ${(props) => props.rafterColor};
	border-bottom: 1px solid ${(props) => props.rafterColor};
	border-top: 1px solid ${(props) => props.rafterColor};
`
const TabNavArrowBody = styled.div`
	color: ${(props) => props.rafterFontColor};
	position: absolute;
	z-index: 2;
	font-size: ${(props) => props.theme.font.fm};
	text-decoration: ${(props) => (props.isActive ? 'underline' : null)};
	font-weight: bold;
	width: calc(100% - 40px);
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
`
const TabsNavBody = styled.div`
	display: flex;
	flex-direction: column;
	border: 1px solid ${(props) => props.theme.colors.TabNav.border};
	padding: 20px;
	background-color: ${(props) => props.theme.background.tab};
`
/////////STYLED/////////

const TabsNavigationsRafters = (props) => {
	const { currentState } = useSelector(
		(state) => ({
			currentState: state,
		}),
		shallowEqual
	)

	const location = useLocation()

	// Breaking point : dynamically we need to know when we stop iterating
	// To do this, we must test URL
	let posBreaking = 0
	const f = find(props.parentObj.routes, (o, k) => {
		if (includes(location.pathname, o.pathName)) {
			posBreaking = k
			return o
		}
	})

	props.setBackPage(!!props.parentObj.backPage)

	const currentStateEvalHandler = (_currentState, obj1) => {
		return eval(`_currentState.${obj1}`)
	}

	const statusId = currentStateEvalHandler(currentState, props.statusPath)

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<>
			<TabsNavigationsRaftersWrapper>
				{map(props.parentObj.routes, (route, key) => {
					const statusVisible = route.statusVisible
					const statusNext = route.statusNext

					let isActive = false
					let isClickable = false
					let isValidated = false

					// Calculate which color and behaviour for our current rafter, based on current status
					let rafterColor = ''
					let rafterFontColor = ''
					if (includes(location.pathname, route.pathName)) {
						rafterColor = Theme.rafters.lightBlue
						rafterFontColor = Theme.colors.white
						isActive = true
						isClickable = true
					} else if (statusId >= statusNext) {
						rafterColor = Theme.rafters.darkBlue
						rafterFontColor = Theme.colors.white
						isClickable = true
					} else {
						rafterColor = Theme.rafters.lightGrey
						rafterFontColor = Theme.rafters.fontGrey
					}

					if (location.pathname.includes(route.pathName.toString())) {
						props.setBackPage(!!route.backPage)
					}

					// If location has an ID, and the next tab link contains ID to replace,
					// We need to do this test to keep this ID in navigation
					let tabLink
					if (route.path.includes(':id')) {
						tabLink = `${!isEqual(props.firstParent, {}) ? props.firstParent.path : ''}${props.parentObj.path}${route.path}`
						const ar = location.pathname.split('/')
						tabLink = tabLink.replace(':id', _.last(ar))
					} else if (route.hasAltPath && route.altPath.includes(':id') && statusId >= statusVisible) {
						// Might need to change the last condition ?
						tabLink = `${!isEqual(props.firstParent, {}) ? props.firstParent.path : ''}${props.parentObj.path}${route.altPath}`
						const ar = location.pathname.split('/')
						tabLink = tabLink.replace(':id', _.last(ar))
					} else {
						tabLink = `${!isEqual(props.firstParent, {}) ? props.firstParent.path : ''}${props.parentObj.path}${route.path}`
					}

					if (statusId >= statusVisible && !props.displayingRafters) {
						props.setDisplayingRafters(true)
					}

					return (
						// If status doesn't permit rafter displaying
						statusId < statusVisible ? null : (
							<TabNavContent
								key={key}
								to={tabLink}
								//positionRafter={route}
								onClick={(e) => {
									if (!isClickable) e.preventDefault()
								}}
								isClickable={isClickable}
							>
								{key === 0 ? <FirstArrowBack rafterColor={rafterColor} /> : null}
								<TabNavArrowTop rafterColor={rafterColor} />
								<TabNavArrowBody rafterColor={rafterColor} rafterFontColor={rafterFontColor} isActive={isActive}>
									<span>{props.translations[route.tabName]}</span>
									{statusId >= route.statusValidated && <img src={valitatedStep} />}
								</TabNavArrowBody>
								<TabNavArrowBottom rafterColor={rafterColor} />
							</TabNavContent>
						)
					)
				})}
			</TabsNavigationsRaftersWrapper>
			<TabsNavBody>{props.children}</TabsNavBody>
		</>
	)
}

TabsNavigationsRafters.propTypes = {}

TabsNavigationsRafters.defaultPropTypes = {}

export default TabsNavigationsRafters
